import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';

const navItems = [
  { name: "Home", path: "/" },
  { name: "Tournaments", path: "/tournaments" },
  { name: "Teams", path: "/teams" },
  { name: "Players", path: "/players" },
  { name: "Matches", path: "/matches" },
  { name: "Statistics", path: "/statistics" },
  { name: "Feedback", path: "/feedback" },
];

export default function MobileSidebar({ open, onClose }) {
  const location = useLocation();
  return (
    <div className={`fixed inset-0 z-50 transition ${open ? 'block' : 'hidden'}`}>
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      {/* Sidebar */}
      <nav className="absolute left-0 top-0 h-full w-64 bg-white shadow-lg p-4 flex flex-col">
        <button className="self-end mb-4" onClick={onClose} aria-label="Close navigation">
          <X className="h-6 w-6" />
        </button>
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`py-2 px-3 rounded ${location.pathname === item.path ? 'bg-accent text-cricket-green' : 'text-gray-700'}`}
            onClick={onClose}
          >
            {item.name}
          </Link>
        ))}
      </nav>
    </div>
  );
} 